<template>
    <section>
        <modal ref="modalInfoClientes" titulo="" :user="cliente.avatar" no-aceptar tamano="modal-lg">
            <div class="row justify-center">
                <div class="">
                    <p class="mb-0 text-muted2 f-600 text-center">
                        {{ cliente.nombre }}
                    </p>
                    <p class="mb-0 text-muted2">
                        Cliente desde {{ cliente.antiguedad }}
                    </p>
                </div>
            </div>
            <div class="row mx-0 justify-center mt-5 mb-2">
                <p class="mb-0 text-muted2 f-14 ">
                    Productos en mayor número de pedidos
                </p>
            </div>
            <div class="row mb-4">
                <div v-for="(producto, p) in productos" :key="p" class="col-4 d-flex justify-content-center">
                    <img :src="producto.logo_mini" class="br-12 border" style="width:71px;height:71px;object-fit:cover;" />
                    <div class="px-2 py-2">
                        <p class="mb-0 text-blue f-600 f-22">
                            {{ producto.cantidad }}
                        </p>
                        <p class="mb-0 text-muted2 f-14">
                            {{ producto.nombre }}
                        </p>
                    </div>
                </div>
            </div>
        </modal>
    </section>
</template>
<script>
import Clientes from "~/services/metricas_admin"
import { mapGetters } from 'vuex'

export default {
    data(){
        return{
            cliente: {
                id: null,
                nombre: '',
                avatar: '',
                antiguedad: '',
            },
            caso: 0,
            id_tienda: 0,
            productos: [],
        }
    },
    computed: {
        ...mapGetters({
            id_cedis:'cedis/id_cedis',
            id_moneda:'cedis/id_moneda',
        }),
    },
    methods: {
        toggle(cliente,caso,id_tienda){
            this.cliente.id = cliente.created_by
            this.cliente.avatar = cliente.avatar
            this.cliente.antiguedad = cliente.antiguedad
            this.cliente.nombre = cliente.nombre
            this.caso = caso
            this.id_tienda = id_tienda
            this.$refs.modalInfoClientes.toggle();
            this.ver_cliente()
        },
        async ver_cliente(){
            try {
                let params = {
                    id_cliente: this.cliente.id,
                    id_moneda: this.id_moneda,
                    id_cedis: this.id_cedis
                }
                const { data } = await Clientes.ver_cliente(params)
                this.productos = data.data.productos

            } catch (error){

            }
        },

    }
}
</script>
